import { MainLogo } from '@/fsd/shared/ui/icons';
import { Link, NavLink } from 'react-router-dom';
import { FAQ_LINKS } from '../../model/consts/faqLinks';
import styles from '../header.module.scss';

const HeaderNavFaq = () => {
  return (
    <div
      className={styles.content}
      style={{ display: 'flex', alignItems: 'center', gap: '40px' }}
    >
      <Link to={'/'} className={styles.logo}>
        <MainLogo />
        <p
          style={{
            textAlign: 'center',
            fontSize: '10px',
            color: '#429EFF',
            textTransform: 'uppercase',
            marginTop: '-3px',
          }}
        >
          База знаний
        </p>
      </Link>
      <nav
        className={styles.nav}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '40px',
          fontWeight: 500,
        }}
      >
        {FAQ_LINKS.map((link, index) => {
          if (link.external) {
            return (
              <Link
                to={link.to}
                key={index}
                rel="noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                {link.label}
                {link.icon && link.icon}
              </Link>
            );
          } else {
            return (
              <NavLink to={link.to} key={index}>
                {link.label}
              </NavLink>
            );
          }
        })}
      </nav>
    </div>
  );
};

export default HeaderNavFaq;
